import React from "react";  

const Login=() => {
  return (
    <div style={{ padding: "4rem", color: "white" }}> 
        <h1>Login Page</h1>
        <p>Here you can log in or register.</p>  
    
    </div> 
    )};

export default Login;